import { Button, Tooltip } from '@mui/material'
import { Visibility } from '@mui/icons-material'
import React from 'react'
import { DocumentButtonSummaryResult } from 'src/viewModels/quotes/DocumentButtonSummaryResult'
import { IQuoteDTO } from 'src/viewModels/quotes/QuoteDTO'

interface IClaimDocumentButtonProps {
  element: DocumentButtonSummaryResult
  selectedQuote?: IQuoteDTO
  episodeOfCareId?: string
}

function QuoteClaimButton(props: IClaimDocumentButtonProps) {
  const isAppeal = props.element.appealTypeDescription !== undefined
  var appealText =
    props.element.appealTypeDescription !== undefined
      ? '[' + props.element.appealTypeDescription + '] '
      : ''
  return (
    <Tooltip
      title={
        <span>
          {props.element.percentageLineItemsReconciled !== undefined
            ? appealText +
              props.element.providerGroup +
              ' - ' +
              props.element.percentageLineItemsReconciled +
              '% Reconciled'
            : appealText + props.element.providerGroup}
          <br />
          DOS: {props.element.dateOfService ? props.element.dateOfService : '[UNKNOWN]'}
          {props.element.movedClaimInfo ? (
            <>
              <br />
              {props.element.movedClaimInfo}
            </>
          ) : null}
        </span>
      }
    >
      <Button
        sx={
          isAppeal
            ? {
                backgroundColor: 'error.main',
                color: 'error.contrastText',
                '&:hover': {
                  backgroundColor: 'error.dark',
                },
              }
            : {}
        }
        variant={
          props.element.percentageLineItemsReconciled === 100 ? 'contained' : 'outlined'
        }
        size="small"
        style={{ margin: '10px' }}
        color={
          props.element.originalBundleQuoteId
            ? 'inherit'
            : isAppeal
              ? undefined
              : 'primary'
        }
        onClick={() => {
          console.log(props.element.episodeOfCareId)
          window.open(
            `/claim/${props.element.claimId}/episodeOfCare/${
              props.element.episodeOfCareId
                ? props.element.episodeOfCareId
                : props.episodeOfCareId!
            }/view`,
            '_blank'
          )
        }}
      >
        <Visibility />
        &nbsp;{props.element.label}
      </Button>
    </Tooltip>
  )
}
export default QuoteClaimButton
